import Entity from "./Entity";

export default class Country extends Entity {
    constructor(data) {
        super(data);
    }
}